// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"c733f7d3","208":"61560cf4","315":"a08bd78d","409":"d990fda4","631":"1a05c407","774":"5ec027eb"}[chunkId] + ".chunk.js";
};